import Icon from './components/Icon';

const IconDelete = ({ ...props }: any) => {
	return <Icon handle={props.handle} id="hpa-delete" {...props} />;
};

export default IconDelete;
